import tfApi from 'tfapi-client'

export const _Reports = {
  namespaced: true,
  state: {
    /**
     * Liste des rapports
     * @type {Array}
     */
    reports: []
  },
  getters: {
    GET_REPORTS: state => state.reports,
    GET_REPORT: state => id => {
      const report = state.reports.find(r => r.id === id)
      if (!report) throw new Error('Unknown report')
      return report
    },
    GET_NEW_REPORT: () => ({
      id: tfApi.NEW_RESOURCE,
      title: 'Nouveau rapport',
      sender: '',
      emails: [],
      sites: [],
      periods: [],
      lang: 'fr',
      isFull: false,
      entreprise: {},
      hasC2cData: true,
      hasChatsData: true,
      hasChatbotData: true,
      hasCSV: false,
      subTitle: '',
      updatedAt: {},
      createdAt: {}
    })
  },
  mutations: {
    INIT (state) {
      state.reports = []
    },
    /**
     * Défini la liste de rapports gérée par le store
     * @param {Array} reports rapports gérés
     */
    SET_REPORTS (state, reports) {
      state.reports = reports
    },
    /**
     * Ajoute un rapport dans la liste
     * @param {Object} report nouveau rapport ajouté
     */
    ADD_REPORT (state, report) {
      state.reports.push(report)
    },
    /**
     * Met à jour un rapport de la liste
     * @param {Object} report rapport à mettre à jour
     */
    UPDATE_REPORT (state, report) {
      const idx = state.reports.findIndex(r => r.id === report.id)
      state.reports.splice(idx, 1, report)
    },
    /**
     * Supprime un rapport de la liste
     * @param {Object} report rapport à supprimer
     */
    REMOVE_REPORT (state, report) {
      const idx = state.reports.findIndex(r => r.id === report.id)
      state.reports.splice(idx, 1)
    }
  },

  actions: {
    /**
     * Récupère les rapports en BDD
     * de l'entreprise et qui ne sont pas full
     */
    async GET_ALL (context) {
      context.commit('INIT')
      try {
        const reports = await tfApi.get(
          `reports/?id=${context.rootState._User.entId}&full=0`
        )
        context.commit('SET_REPORTS', reports)
      } catch (e) {
        console.error(e)
      }
    },
    /**
     * Récupère un rapport en BDD
     */
    async GET (_, reportId) {
      return tfApi.get(`reports/${reportId}`)
    },
    /**
     * Supprime un rapport en BDD
     */
    async DELETE ({ commit }, report) {
      try {
        await tfApi.delete(`reports/${report.id}`)
        commit('REMOVE_REPORT', report)
      } catch (e) {
        console.error(e)
      }
    },
    /**
     * Ajoute un rapport en BDD
     */
    async SAVE (_, report) {
      try {
        await tfApi.setOrUpdate(`reports`, report)
      } catch (e) {
        console.error(e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reports.js